import { Injectable } from '@angular/core';

declare global {
  interface Window {
    createStreamingWidget?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class VoiceAgentService {
  private widget: any = null;
  private jsElement: HTMLScriptElement | null = null;
  private initialized = false;

  init(payload: any) {
    // SSR guard
    if (typeof window === 'undefined') {
      return;
    }

    if (this.initialized) {
      return;
    }

    const host = document.getElementById('my-main-container');
    if (!host) {
      console.error('Main container #my-main-container not found');
      return;
    }


    // ✅ Load widget script ONCE
    if (!this.jsElement) {
      this.jsElement = document.createElement('script');
      this.jsElement.src = 'https://moeez.nemtalk.com/standalone-widget/streaming-widget-standalone.js';
      document.head.appendChild(this.jsElement);
    }

    this.jsElement.onload = () => {
      if (typeof window.createStreamingWidget !== 'function') {
        console.error('❌ createStreamingWidget not found on window');
        return;
      }

      // ✅ Pass the SHADOW ROOT HOST as container
      this.widget = window.createStreamingWidget({
        container: host,
        transparent: true,
        stripBackground: true,
        isallowwidget: true,
        ...payload
      });

      this.initialized = true;
      console.log('🎉 Voice Agent Widget initialized');
    };

    this.jsElement.onerror = function () {
      console.error('❌ Failed to load streaming-widget.js');
    };
  }

  destroy() {
    if (this.widget && typeof this.widget.cleanup === 'function') {
      this.widget.cleanup();
    }

    this.widget = null;

    if (this.jsElement) {
      this.jsElement.remove();
      this.jsElement = null;
    }

    this.initialized = false;

    console.log('🧹 Voice Agent Widget destroyed');
  }
}
